import $ from "jquery";
import Data from "./Data";
import Vue from "vue";

export default class ProductDataCheck {
    private product:any;

    constructor(product:any) {
        this.product = product;

        this.checkGlassDrawingPDF();
        this.checkDilatationCurvesPDF();
        this.checkZoomPicture();
        this.getFinishedProductsData();
    }
    /**
     * The function beforeSendToken sets the Authorization header with a Bearer token in the
     * XMLHttpRequest object if the platform ID is "MYVERALLIA".
     * @param {any} xhr - The `xhr` parameter in the `beforeSendToken` function is typically an
     * XMLHttpRequest object used for making HTTP requests in JavaScript. It is commonly used to set
     * request headers, handle responses, and manage the communication between the client and server.
     */
    private beforeSendToken(xhr: any) {
        //@ts-ignore
        if (Data.data.platform.id == "MYVERALLIA") xhr.setRequestHeader("Authorization", "Bearer " + window.sfdc_ws_token);
    }



    //GLASSDRAWING PDF
    /**
     * The function `checkGlassDrawingPDF` checks if the platform is INTERNAL or MYVERALLIA and then
     * makes an AJAX call to retrieve a PDF file.
     * @returns If the platform ID is not "INTERNAL" or "MYVERALLIA", the function will return and not
     * execute the rest of the code block.
     */
    private checkGlassDrawingPDF(){
        if (Data.data.platform.id != "INTERNAL" && Data.data.platform.id != "MYVERALLIA") return;

        $.ajax({ method: "GET", url: Data.data.platform.sharePointFilesURL + "GlassDrawings/" + this.product.glassDrawing + ".pdf", beforeSend: this.beforeSendToken.bind(this) }).done(this.checkGlassDrawingCall.bind(this));
    }
    /**
     * The function `checkGlassDrawingCall` updates the glass drawing link for a product based on the
     * response status and platform information.
     * @param {any} response - The `response` parameter in the `checkGlassDrawingCall` function is an
     * object that contains information about the result of a request. It is checked to ensure that the
     * status is "success" before updating the `glassDrawingLink` property of the `product` object and
     * potentially other objects based on
     */
    private checkGlassDrawingCall(response:any){
        if (response && response.status == "success") {
            Vue.set(this.product, "glassDrawingLink", response.data["@microsoft.graph.downloadUrl"]);

            if (Data.data.platform.id == "MYVERALLIA"){
                if (Data.data.view == "general" && Data.myProductsJson[this.product.id]){
                    Vue.set(Data.myProductsJson[this.product.id], "glassDrawingLink", response.data["@microsoft.graph.downloadUrl"]);
                } else if (Data.data.view == "myproducts" && Data.productsJson[this.product.id]) {
                    Vue.set(Data.productsJson[this.product.id], "glassDrawingLink", response.data["@microsoft.graph.downloadUrl"]);
                }
            }
        }
    }


    //DILATATION CURVES PDF
    /**
     * The function `checkDilatationCurvesPDF` checks if the platform ID is INTERNAL or MYVERALLIA,
     * then makes an AJAX request to retrieve a PDF file related to glass drawing.
     * @returns A private function named `checkDilatationCurvesPDF` is being returned. This function
     * checks the platform ID and makes an AJAX request to retrieve a PDF file based on certain
     * conditions.
     */
    private checkDilatationCurvesPDF() {
        if (Data.data.platform.id != "INTERNAL" && Data.data.platform.id != "MYVERALLIA") return;

        $.ajax({ method: "GET", url: Data.data.platform.sharePointFilesURL + "DilatationCurves/C_" + this.product.glassDrawingSimplified + ".pdf", beforeSend: this.beforeSendToken.bind(this) }).done(this.checkDilatationCurvesCall.bind(this));
    }
    /**
     * The function `checkDilatationCurvesPDF` checks if the platform ID is either "INTERNAL" or
     * "MYVERALLIA" before making an AJAX request to retrieve a PDF file related to dilatation curves.
     * @returns A private function named `checkDilatationCurvesPDF` is being returned. This function
     * checks the platform ID and makes an AJAX request to retrieve a PDF file based on certain
     * conditions.
     */
    private checkDilatationCurvesCall(response: any){
        if (response && response.status == "success") {
            Vue.set(this.product, "dilatationCurvesLink", response.data["@microsoft.graph.downloadUrl"]);

            if (Data.data.platform.id == "MYVERALLIA") {
                if (Data.data.view == "general" && Data.myProductsJson[this.product.id]) {
                    Vue.set(Data.myProductsJson[this.product.id], "dilatationCurvesLink", response.data["@microsoft.graph.downloadUrl"]);
                } else if (Data.data.view == "myproducts" && Data.productsJson[this.product.id]) {
                    Vue.set(Data.productsJson[this.product.id], "dilatationCurvesLink", response.data["@microsoft.graph.downloadUrl"]);
                }
            }
        }
    }


    //ZOOM PICTURE
    /**
     * The function `checkZoomPicture` checks if a user can access high-definition pictures based on
     * the platform and user permissions before making an AJAX request to check for a specific image.
     * @returns If the platform ID is "SELECTIVELINE" or if the platform ID is "MYVERALLIA" and the
     * user does not have access to HD pictures, then the function `checkZoomPicture` will return
     * without making the AJAX request. Otherwise, it will make an AJAX request to check the
     * availability of a zoom picture for a specific product.
     */
    public checkZoomPicture(){
        if (Data.data.platform.id == "SELECTIVELINE") return;
        if (Data.data.platform.id == "MYVERALLIA" && !Data.data.MYVeralliaUserCanAccessHDPictures) return;

        $.ajax({ method: "HEAD", url: Data.data.platform.productsImages + "zoom/" + this.product.baseProducts[this.product.bpIndex] + ".jpg", success: this.checkZoomPictureCall.bind(this) }).done(this.checkZoomPictureCall.bind(this));
    }
    /**
     * The function `checkZoomPictureCall` updates the `zoomPicture` property of certain objects based
     * on specific conditions.
     * @param {any} response - The `response` parameter in your `checkZoomPictureCall` function is
     * typically used to store the response data from an API call or network request. It can contain
     * information such as the status of the request, response data, headers, and more. In your
     * function, you are checking if the request
     * @param {any} text - The `checkZoomPictureCall` function takes three parameters: `response`,
     * `text`, and `request`. In the provided code snippet, the `text` parameter is not being used
     * within the function. It seems like it might have been intended for some purpose but is currently
     * unused in the function logic
     * @param {any} request - The `request` parameter in the `checkZoomPictureCall` function is
     * typically an object that contains information about the HTTP request being made, such as the
     * status of the request (e.g., 200 for a successful request). In this function, the code checks if
     * the request status is 200
     */
    private checkZoomPictureCall(response:any, text:any, request:any){
        if (request && request.status == 200) {
            Vue.set(Data.data.baseProducts[this.product.baseProducts[this.product.bpIndex]], "zoomPicture", true);

            if (Data.data.platform.id == "MYVERALLIA") {
                if (Data.data.view == "general" && Data.data.myProductsBaseProducts[this.product.baseProducts[this.product.bpIndex]]) {
                    Vue.set(Data.data.myProductsBaseProducts[this.product.baseProducts[this.product.bpIndex]], "zoomPicture", true);
                } else if (Data.data.view == "myproducts" && Data.data.baseProducts[this.product.baseProducts[this.product.bpIndex]]) {
                    Vue.set(Data.data.baseProducts[this.product.baseProducts[this.product.bpIndex]], "zoomPicture", true);
                }
            }
        }
    }




    /**
     * The function `getFinishedProductsData` retrieves data for finished products if the platform ID
     * is INTERNAL.
     * @returns If the platform ID in the `Data.data` object is not equal to "INTERNAL", then nothing
     * will be returned. The `getFinishedProductsData` function will exit without returning anything.
     */
    public getFinishedProductsData(){
        if (Data.data.platform.id != "INTERNAL") return;

        this.getFinishedProducts(this.product.baseProducts[this.product.bpIndex]);
    }
    /**
     * The function `getFinishedProducts` retrieves finished products data based on a given base
     * product ID.
     * @param {string} baseProductID - The `baseProductID` parameter is a string that represents the
     * unique identifier of a base product. It is used to retrieve information about the base product
     * and its corresponding finished products.
     * @returns If the `Data.data.finishedProducts` object already contains a property with the key
     * `baseProductID`, then the function will return without making an AJAX request.
     */
    private getFinishedProducts(baseProductID:string){
        let baseProduct: any = Data.data.baseProducts[baseProductID];
        if (Data.data.finishedProducts[baseProductID]) return;

        $.ajax({ method: "GET", url: Data.data.platform.finishedProductsURL + this.product.baseProducts[this.product.bpIndex] }).done(this.setFinishedProducts.bind(this, baseProductID));
    }
    /**
     * The function `setFinishedProducts` processes a response to populate a list of finished products
     * based on a given base product ID.
     * @param {string} baseProductID - The `baseProductID` parameter is a string that represents the ID
     * of a base product. It is used to identify a specific base product in the system.
     * @param {any} response - The `setFinishedProducts` function takes in two parameters:
     * `baseProductID` and `response`. The `response` parameter is expected to be an object containing
     * information about the status and data of the response from an API call or some other source.
     * @returns The `setFinishedProducts` function is not explicitly returning any value. It is a void
     * function that performs operations on the `finishedProducts` data based on the `response`
     * received.
     */
    private setFinishedProducts(baseProductID:string, response:any){
        let baseProduct: any = Data.data.baseProducts[baseProductID];
        if (!Data.data.finishedProducts[baseProductID]) Data.data.finishedProducts[baseProductID] = [];

        let finishedProducts:any = null;
        try {
            if (response.status == "success" && response.data) finishedProducts = response.data;
        } catch (e) {
            return;
        }


        //if (finishedProducts && finishedProducts.length != 0 && finishedProducts[0].baseProduct == baseProductID) {
        if (finishedProducts && finishedProducts.length != 0) {
            baseProduct.selected_line = 0;

            let a: number = finishedProducts.length;
            for (let i=0; i<a; i++) {

                finishedProducts[i].id = finishedProducts[i]._id;
                delete finishedProducts[i]._id;

                finishedProducts[i].quantity = 1;
                finishedProducts[i].display = true;

                if (finishedProducts[i].materialGroup) {
                    if (finishedProducts[i].materialGroup.toLowerCase() == "naac" || finishedProducts[i].materialGroup.toLowerCase() == "naaa" || finishedProducts[i].materialGroup.toLowerCase() == "naba" || finishedProducts[i].materialGroup.toLowerCase() == "nabc") finishedProducts[i].display = true;
                    else finishedProducts[i].display = false;
                }

                if (!finishedProducts[i].materialGroup) finishedProducts[i].display = false;
                //if(finishedProducts[i].status && finishedProducts[i].status.toLowerCase() == "z3") finishedProducts[i].display = false;
                if (finishedProducts[i].status && finishedProducts[i].status.toLowerCase() == "z1") finishedProducts[i].display = false;

                let status:any = ["st", "sr"];
                if (finishedProducts[i].standard && status.indexOf(finishedProducts[i].standard.toLowerCase()) == -1) finishedProducts[i].display = false;
                if (!finishedProducts[i].standard) finishedProducts[i].display = false;

                if (finishedProducts[i].display) Data.data.finishedProducts[baseProductID].push(finishedProducts[i]);
            }
        }

        if (Data.data.finishedProducts[baseProductID].length > 0) this.getFinishedProductStock(baseProductID);
    }



    /**
     * The function `getFinishedProductStock` retrieves the stock information for finished products
     * based on a given base product ID.
     * @param {string} baseProductID - The `baseProductID` parameter is a string that represents the ID
     * of a base product for which you want to retrieve the finished product stock information.
     * @returns The `getFinishedProductStock` function is checking if the platform ID is not "INTERNAL"
     * before proceeding with the rest of the function. If the platform ID is not "INTERNAL", the
     * function will return early without executing the rest of the code.
     */
    private getFinishedProductStock(baseProductID: string) {
        if (Data.data.platform.id != "INTERNAL") return;

        let url: string = Data.data.platform.finishedProductsStockURL;
        let str:string;
        for (str in Data.data.finishedProducts[baseProductID]){
            url += Data.data.finishedProducts[baseProductID][str].id + ",";
        }

        //url += "&lang=" + Data.data.language;
        url += "&lang=" + Data.data.config.oldLanguagesMapping[Data.data.language];

        $.ajax({ method: "GET", url: url }).done(this.setFinishedProductStock.bind(this, baseProductID));
    }
    /**
     * The function `setFinishedProductStock` retrieves and processes stock data for finished products
     * based on a given base product ID.
     * @param {string} baseProductID - The `baseProductID` parameter in the `setFinishedProductStock`
     * function is a string that represents the ID of a base product for which the finished product
     * stock data is being set. This ID is used to retrieve and update the stock data for the
     * corresponding finished products associated with the base product.
     * @param {any} response - The `setFinishedProductStock` function seems to be processing XML data
     * to extract stock information for finished products based on a given base product ID. The
     * function parses the XML response and extracts relevant stock data for each finished product
     * associated with the base product ID.
     * @returns The function `setFinishedProductStock` is not explicitly returning any value. It is
     * primarily focused on processing the `response` data and updating the `stockData` object based on
     * certain conditions and data manipulation. The final result of this function is the update of the
     * `Data.data.finishedProductsStocks` object with the `stockData` for the specified
     * `baseProductID`.
     */
    private setFinishedProductStock(baseProductID: string, response: any){
        let xml: any;

        try{
            xml = $(response)[2];
        }catch(e:any){
            console.log("error getting dtock data, trying another method", e);
        }

        if(!xml){
            try {
                xml = $(response)[0];
            } catch (e: any) {
                console.log("error getting dtock data", e);
            }
        }

        if (!xml) return;

        let stockData: any = {};

        let str:string;
        for (str in Data.data.finishedProducts[baseProductID]){
            let finishedProduct: any = Data.data.finishedProducts[baseProductID][str];

            if (!finishedProduct.materialGroup) continue;
            if (finishedProduct.materialGroup && finishedProduct.materialGroup.toLowerCase() == "naad") continue;

            if (!stockData[finishedProduct.id]) stockData[finishedProduct.id] = [];

            $(xml).find("EItemFp").find("item").each(function (index) {
                let code:string = String(Number($(this).find('ProductCode').text()));

                let company:string = $(this).find('Company').text();
                if (company && company != "") {
                    if (company == "S09" || company == "S08") return;
                }

                let plantcode:string = $(this).find('PlantCode').text();
                if (plantcode && plantcode != "") {
                    if (plantcode == "D830" || plantcode == "D500" || plantcode == "D700") return;
                }


                if (code.indexOf(finishedProduct.id) == -1) return;


                let stock:any = {};

                stock.Code = code;
                stock.BaseUnit = $(this).find('BaseUnit').text();
                stock.ProductCode = $(this).find('ProductCode').text();
                stock.ProductDescription = $(this).find('ProductDescription').text();
                stock.Country = $(this).find('Country').text();
                if (stock.Country) stock.Country = stock.Country.toLowerCase();
                stock.PlantCode = $(this).find('PlantCode').text();
                stock.PlantText = $(this).find('PlantText').text();
                stock.FreeStock = $(this).find('FreeStock').text();
                stock.BlockedStock = $(this).find('BlockedStock').text();
                stock.PartsVendorStock = $(this).find('PartsVendorStock').text();
                stock.OrdersOnhandStock = $(this).find('OrdersOnhandStock').text();
                stock.SalesReqQty = $(this).find('SalesReqQty').text();
                stock.ProdDateFrom = $(this).find('ProdDateFrom').text();
                if (stock.ProdDateFrom == "0000-00-00") stock.ProdDateFrom = "";
                stock.ProdDateTo = $(this).find('ProdDateTo').text();
                stock.ProdTotalQty = $(this).find('ProdTotalQty').text();
                stock.ProdRemainQty = $(this).find('ProdRemainQty').text();
                stock.StckInTransit = $(this).find('StckInTransit').text();
                stock.StckInTransitUsed = 0;

                stock.StckInTransitUb = $(this).find('StckInTransitUb').text();
                stock.StckInTransitEb = $(this).find('StckInTransitEb').text();

                stock.quantity = Number(stock.FreeStock) - Number(stock.SalesReqQty);

                if (stock.StckInTransitUb < 0) {
                    stock.quantity += Number(stock.StckInTransitUb);
                }
                if (stock.StckInTransitEb < 0) {
                    stock.quantity += Number(stock.StckInTransitEb);
                }

                if (stock.StckInTransitUb > 0) {
                    stock.StckInTransitUsed += Number(stock.StckInTransitUb);
                }
                if (stock.StckInTransitEb > 0) {
                    stock.StckInTransitUsed += Number(stock.StckInTransitEb);
                }

                stock.quantity += Number(stock.StckInTransitUsed);

                if (stock.quantity != 0 || Number(stock.ProdRemainQty) > 0) {
                    stockData[finishedProduct.id].push(stock);
                }

            })

            if (stockData[finishedProduct.id].length == 0) delete stockData[finishedProduct.id];
        }


        //@ts-ignore
        Vue.set(Data.data.finishedProductsStocks, baseProductID, stockData);

        // var a = t.baseproduct.fip.length;
        // for (var i = 0; i < a; i++) {
        //     var fp = t.baseproduct.fip[i];


        //     var status = true;
        //     if (fp.materialGroup.toLowerCase() != "naad" && status == true) {
        //         fp.stock = {};

        //         $(data[2]).find("EItemFp").find("item").each(function (index) {
        //             var code = $(this).find('ProductCode').text();

        //             var company_good = true;
        //             var company = $(this).find('Company').text();
        //             if (company && company != "") {
        //                 if (company == "S09" || company == "S08") company_good = false;
        //             }

        //             var plantcode = $(this).find('PlantCode').text();
        //             if (plantcode && plantcode != "") {
        //                 if (plantcode == "D830" || plantcode == "D500" || plantcode == "D700") company_good = false;
        //             }

        //             if (code.indexOf(t.baseproduct.fip[i].id) != -1 && company_good == true) {
        //                 var stock = {};

        //                 stock.BaseUnit = $(this).find('BaseUnit').text();
        //                 stock.ProductCode = $(this).find('ProductCode').text();
        //                 stock.ProductDescription = $(this).find('ProductDescription').text();
        //                 stock.Country = $(this).find('Country').text();
        //                 stock.PlantCode = $(this).find('PlantCode').text();
        //                 stock.PlantText = $(this).find('PlantText').text();
        //                 stock.FreeStock = $(this).find('FreeStock').text();
        //                 //fp.stock.FreeStock = Math.round(Math.random() * 200000);
        //                 stock.BlockedStock = $(this).find('BlockedStock').text();
        //                 stock.PartsVendorStock = $(this).find('PartsVendorStock').text();
        //                 stock.OrdersOnhandStock = $(this).find('OrdersOnhandStock').text();
        //                 stock.SalesReqQty = $(this).find('SalesReqQty').text();
        //                 //fp.stock.SalesReqQty = Math.round(Math.random() * 50000);
        //                 stock.ProdDateFrom = $(this).find('ProdDateFrom').text();
        //                 if (stock.ProdDateFrom == "0000-00-00") stock.ProdDateFrom = "";
        //                 stock.ProdDateTo = $(this).find('ProdDateTo').text();
        //                 stock.ProdTotalQty = $(this).find('ProdTotalQty').text();
        //                 stock.ProdRemainQty = $(this).find('ProdRemainQty').text();
        //                 stock.StckInTransit = $(this).find('StckInTransit').text();
        //                 stock.StckInTransitUsed = 0;

        //                 stock.StckInTransitUb = $(this).find('StckInTransitUb').text();
        //                 stock.StckInTransitEb = $(this).find('StckInTransitEb').text();

        //                 stock.quantity = Number(stock.FreeStock) - Number(stock.SalesReqQty);

        //                 if (stock.StckInTransitUb < 0) {
        //                     stock.quantity += Number(stock.StckInTransitUb);
        //                 }
        //                 if (stock.StckInTransitEb < 0) {
        //                     stock.quantity += Number(stock.StckInTransitEb);
        //                 }

        //                 if (stock.StckInTransitUb > 0) {
        //                     stock.StckInTransitUsed += Number(stock.StckInTransitUb);
        //                 }
        //                 if (stock.StckInTransitEb > 0) {
        //                     stock.StckInTransitUsed += Number(stock.StckInTransitEb);
        //                 }

        //                 stock.quantity += Number(stock.StckInTransitUsed);

        //                 if (stock.quantity != 0 || Number(stock.ProdRemainQty) > 0) {
        //                     fp.stock[code + stock.PlantCode] = stock;

        //                     if (!t.stock_data[t.baseproduct.fip[i].id]) t.stock_data[t.baseproduct.fip[i].id] = { fip: {}, quantity: 0 };
        //                     t.stock_data[t.baseproduct.fip[i].id].fip[code + stock.PlantCode] = stock;

        //                     if (t.countries.indexOf(stock.Country.toLowerCase()) == -1) {
        //                         t.countries.push(stock.Country.toLowerCase());
        //                     }
        //                 }
        //             }
        //         })
        //     }
        //}
    }
}